import React, { Dispatch, SetStateAction } from 'react'
import Picker from '@components/Picker'
import { FilterListIcon } from '@components/Icons'
import { colors } from '@lib/colors'
import { StyleSheet, View } from 'react-native'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST.STATUS

const workOrderFilterOptions = [
  'Draft',
  'Active',
  'In Progress',
  'Work Completed',
]

interface WorkOrderFiltersProps {
  setStatusFilter: Dispatch<SetStateAction<WorkOrderStatusName | undefined>>
}

export default function (props: WorkOrderFiltersProps) {
  const { setStatusFilter } = props

  return (
    <View
      style={ styles.wrapper }
    >
      <Picker
        style={ pickerStyle }
        labelStyle={ styles.pickerLabel }
        borderStyle={ styles.pickerBorder }
        onValueChange={ (value) => setStatusFilter(value as WorkOrderStatusName | undefined) }
        placeholder={ COPY.ALL }
        items={ workOrderFilterOptions?.map((w) => ({ label: COPY[w as keyof typeof COPY], value: w })) }
      />
      <FilterListIcon
        size={ 20 }
        color={ colors.blue[500] }
      />
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: -10,
  },
  text: {
    color: colors.blue[500],
    fontWeight: '600',
    marginRight: 8,
  },
  pickerBorder: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    alignItems: 'center',
  },
  pickerLabel: {
    backgroundColor: 'transparent',
  },
})

const pickerStyle = StyleSheet.create({
  inputIOS: {
    color: colors.blue[500],
    padding: 10,
    fontWeight: '600',
  },
  inputAndroid: {
    color: colors.blue[500],
    padding: 10,
    fontWeight: '600',
  },
  placeholder: {
    color: colors.blue[500],
    padding: 10,
    fontWeight: '600',
  },
})
